// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  useLegalEntityV3: true,
  dentoFormTransfertDate: 1727740800000, // Epoch time for october 1st 2024 GMT in miliseconds
  webApiUrl: "https://odqservicegestionodqfarp-dev.azurewebsites.net/api",
  legalEntityCommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/legalentity-commandapi/api",
  legalEntityQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/legalentity-queryapi/api",
  legalEntityV3QueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/legalentity-v3-queryapi/api",
  continuingEducationOdataQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-queryapi/odata",
  continuingEducationQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-queryapi/api",
  legalEntityV3CommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/legalentity-v3-commandapi/api",
  continuingEducationCommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-commandapi/api",
  continuingEducationV3CommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-v3-commandapi/api",
  continuingEducationV3QueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-v3-queryapi/api",
  continuingEducationV3OdataQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-v3-queryapi/odata",
  projectionQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/registrar-queryapi/odata",
  projectionApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/registrar-queryapi/api",
  referenceTableQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/referencetablemanager-queryapi/odata",
  registrarCommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/registrar-commandapi/api",
  registrarPaymentApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/registrarpayment-commandapi/api",
  anonymousPaymentApiKey: "sdywj3Wcn3byLWi1HM9DwOm2dxQZbgZoYMshAw/OCR4=",
  registrarQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/registrar-queryapi/api",
  signalRApi: "https://signalr-notification-dev.azurewebsites.net/api",
  farpQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/farp-queryapi/api",
  farpCommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/farp-commandapi/api",
  inspectionQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/inspection-queryapi/api",
  inspectionCommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/inspection-commandapi/api",
  documentStorageUrl: "https://platinepersistence.blob.core.windows.net",
  dentalAssistantQueryApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/dentalassistant-queryapi/api",
  disciplinaryBoardApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/odq-disciplinaryboard-api/api",
  dentalAssistantCommandApi:
    "https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/dentalassistant-commandapi/api",
  generalPublicFarpApi: "https://generalpublic-farp-dev.azurewebsites.net/api",
  generalPublicOdqApi: "https://generalpublic-odq-dev.azurewebsites.net/api",
  inspectionEnabled: true,
  canadaPostApiKey: "UN71-CM46-AG69-ZX94",
  identity: {
    clientId: "ea3d4241-af16-4b6a-b606-2ea005e38c5c",

    // tslint:disable-next-line: max-line-length
    authority:
      "https://supportodqqcdev.b2clogin.com/supportodqqcdev.onmicrosoft.com/B2C_1A_AUTHCODE-PORTAL-USERNAMEOREMAIL-SIGNIN_V2/v2.0/",

    // tslint:disable-next-line: max-line-length
    authorityResetPassword:
      "https://supportodqqcdev.b2clogin.com/supportodqqcdev.onmicrosoft.com/B2C_1A_AUTHCODE-PORTAL-USERNAMEOREMAIL-PASSWORDRESET_V2/v2.0/",

    redirectUri: "/oidc-signin-callback",
    postLogoutRedirectUri: "/oidc-signout-callback",
    silentRedirectUri: "/assets/silent-callback.html",
    // tslint:disable-next-line: max-line-length
    consentScopes: [
      "openid",
      "profile",
      "https://supportodqqcDev.onmicrosoft.com/platinebackend/legalentity.command",
      "https://supportodqqcDev.onmicrosoft.com/platinebackend/continuingeducation.command",
    ],
    accountCreation:
      "https://supportodqqcdev.b2clogin.com/supportodqqcDev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_PortalUserCreation&client_id=ea3d4241-af16-4b6a-b606-2ea005e38c5c&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fodqplatinewebclient-dev.odq.qc.ca%2Fhome&scope=openid&response_type=code&prompt=login&code_challenge_method=S256&code_challenge=0kwYa6mOScZk6AEQ7JQ8oyxr7YEOWVqVQ1P6aWoZ1So",
  },
  firebase: {
    apiKey: "AIzaSyBlAEqpEXG0cSXzvXG6HwsMG6DEhHfbpzc",
    authDomain: "platine-backoffice.firebaseapp.com",
    databaseURL: "https://platine-backoffice.firebaseio.com",
    projectId: "platine-backoffice",
    storageBucket: "platine-backoffice.appspot.com",
    messagingSenderId: "124934093345",
    appId: "1:124934093345:web:76c1bb5fd480690d",
  },
  shoppingCart: {
    monerisOriginUrl: "https://esqa.moneris.com",
    monerisBaseUrl: "https://esqa.moneris.com/HPPtoken/index.php",
    companyMonerisStoreId: "htYR1VECTH4SZ9H",
    inscriptionMonerisStoreId: "htYR1VECTH4SZ9H",
    subscriptionMonerisStoreId: "htYR1VECTH4SZ9H",
    dentalAssistantMonerisStoreId: "htYR1VECTH4SZ9H",
    defaultNoticeMonerisStoreId: "htYR1VECTH4SZ9H",
    studentPaymentMonerisStoreId: "htYR1VECTH4SZ9H",
    memberPaymentMonerisStoreId: "htYR1VECTH4SZ9H",
    disciplinaryBoardPaymentMonerisStoreId: "htYR1VECTH4SZ9H",
    farpOdqBillPaymentMonerisStoreId: "htYR1VECTH4SZ9H",
  },
  functions: {
    baseUrl: "https://odqplatineportalfuncs-dev.azurewebsites.net/api",
  },
  annualFormDirectives: {
    fr: {
      url: `https://platinepersistence.blob.core.windows.net/web-client-capsules-information/Capsules_information_FRA.pdf`,
      name: "Capsules_information_FRA.pdf",
    },
    en: {
      url: `https://platinepersistence.blob.core.windows.net/web-client-capsules-information/Capsules_information_ENG.pdf`,
      name: `Capsules_information_ENG.pdf`,
    },
  },
  conventionAcceptationRepondant: {
    url: `https://platinepersistence.blob.core.windows.net/web-client-capsules-information/Convention_acceptation_repondant.pdf`,
    name: `Convention_acceptation_repondant.pdf`,
  },
  monitoring: {
    fullStoryOrgId: "VC0BC",
  },
  surveyJsLicenseKey:
    "ZmFmMDk5NGMtNjQ0OS00YjYzLWI2OWItOWU1MGMwN2RlMjA1OzE9MjAyNC0xMi0wNywyPTIwMjQtMTItMDcsND0yMDI0LTEyLTA3",
  devExtremeSubscriptionLicenseKey:
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjRkYWE4OTU4LWI5MTQtNDViNC05ZGVlLTg5OWIzNTI3YzNiMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.DiBmaMQdZwCuOLQcwr5fypRDLLDalSD11fVeJEne0AGAr0++MMyaFmml8K0YvYnqaqCqaaCwwAUb1kWsVvmCAqNIWKDqRmLGEFFHjphdL0wR/aJCCACH/gBJzYDqI02DRnPHxQ=='
};
